import { createClient } from "@supabase/supabase-js";

// These will be set from your Supabase project dashboard
// Go to: https://supabase.com → New Project → Settings → API
const supabaseUrl = process.env.REACT_APP_SUPABASE_URL || "";
const supabaseAnonKey = process.env.REACT_APP_SUPABASE_ANON_KEY || "";

// Only create client if configured — prevents crash with empty URL
export const supabase =
  supabaseUrl && supabaseAnonKey
    ? createClient(supabaseUrl, supabaseAnonKey)
    : null;

// Helper: check if Supabase is configured
export const isSupabaseConfigured = () => {
  return supabase !== null;
};
